import request from '@/tools/request'

export default ({ app }, inject) => {
  window.$request = request
  return inject('request', request)
}
